import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-snitem-table-row-icons',
  templateUrl: './snitem-table-row-icons.component.html',
  styleUrls: ['./snitem-table-row-icons.component.scss']
})
export class SNItemTableRowIconsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
